import { useSimulationStatus } from '../../hooks';

interface CountdownClockProps {
  className?: string;
}

export function CountdownClock({ className }: CountdownClockProps) {
  const status = useSimulationStatus();

  if (status.state !== 'running' && status.state !== 'paused') {
    return null;
  }

  const { simulationTimeS, remainingS } = status;
  const isPaused = status.state === 'paused';
  const prefix = isPaused ? 'PAUSED - ' : '';

  // Countdown mode: remainingS is set and positive
  if (remainingS != null && remainingS > 0) {
    const mm = Math.floor(remainingS / 60);
    const ss = Math.floor(remainingS % 60)
      .toString()
      .padStart(2, '0');
    const color = isPaused ? 'text-state-paused' : remainingS < 60 ? 'text-feedback-error' : 'text-feedback-warning';

    return (
      <span className={`${color} ml-8 font-mono ${className ?? ''}`}>
        {prefix}
        {mm}:{ss}
      </span>
    );
  }

  // Stopwatch mode: no auto-pause or countdown expired
  const mm = Math.floor(simulationTimeS / 60);
  const ss = Math.floor(simulationTimeS % 60)
    .toString()
    .padStart(2, '0');
  const color = isPaused ? 'text-state-paused' : 'text-text-muted';

  return (
    <span className={`${color} ml-8 font-mono ${className ?? ''}`}>
      {prefix}
      {mm}:{ss}
    </span>
  );
}
